/* ==========================================================================
   Closed Shop — Bestaetigungsseite: Kalender-Buttons
   --------------------------------------------------------------------------
   Baut aus den Theme-Editor-Settings zwei Links:
   - Google Kalender (Render-URL)
   - Apple / Outlook (.ics als Blob-URL, siehe icsHref weiter unten)

   Startzeit kommt als ISO-String mit Offset (z.B. 2026-08-15T10:00:00+02:00),
   die Umrechnung nach UTC macht der Browser. Laeuft auch mehrfach (Theme-
   Editor rendert Sections neu) und ueberspringt bereits verdrahtete Blocks.
   ========================================================================== */
(function () {
  'use strict';

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  // 2026-08-15T08:00:00Z -> 20260815T080000Z
  function toIcsUtc(date) {
    return (
      date.getUTCFullYear() +
      pad(date.getUTCMonth() + 1) +
      pad(date.getUTCDate()) +
      'T' +
      pad(date.getUTCHours()) +
      pad(date.getUTCMinutes()) +
      pad(date.getUTCSeconds()) +
      'Z'
    );
  }

  // RFC 5545: Backslash, Semikolon, Komma und Umbrueche muessen escaped werden
  function icsEscape(text) {
    return String(text)
      .replace(/\\/g, '\\\\')
      .replace(/;/g, '\\;')
      .replace(/,/g, '\\,')
      .replace(/\r?\n/g, '\\n');
  }

  // Zeilen ueber 75 Oktetts falten, sonst weisen strenge Parser die Datei ab
  function icsFold(line) {
    if (line.length <= 74) return line;
    var out = line.slice(0, 74);
    var rest = line.slice(74);
    while (rest.length > 73) {
      out += '\r\n ' + rest.slice(0, 73);
      rest = rest.slice(73);
    }
    return out + '\r\n ' + rest;
  }

  function buildIcs(opts) {
    var lines = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'CALSCALE:GREGORIAN',
      'METHOD:PUBLISH',
      'PRODID:-//Ladypolitan//Closed Shop//DE',
      'BEGIN:VEVENT',
      'UID:' + opts.uid,
      'DTSTAMP:' + toIcsUtc(opts.stamp),
      'DTSTART:' + toIcsUtc(opts.start),
      'DTEND:' + toIcsUtc(opts.end),
      'SUMMARY:' + icsEscape(opts.title),
      'DESCRIPTION:' + icsEscape(opts.details)
    ];

    if (opts.url) lines.push('URL:' + opts.url);

    if (opts.reminderMinutes > 0) {
      lines.push(
        'BEGIN:VALARM',
        'ACTION:DISPLAY',
        'DESCRIPTION:' + icsEscape(opts.title),
        'TRIGGER:-PT' + opts.reminderMinutes + 'M',
        'END:VALARM'
      );
    }

    lines.push('END:VEVENT', 'END:VCALENDAR');

    return lines.map(icsFold).join('\r\n');
  }

  /*
   * Der Download-Link muss same-origin sein. Eine data:-URI hat einen opaken
   * Origin, deshalb ignoriert Safari dort das download-Attribut und blockiert
   * obendrein die Navigation dorthin: Auf dem iPhone passierte beim Tippen
   * schlicht nichts. Eine blob:-URL erbt den Origin der Seite, damit greift
   * download wieder und iOS reicht die Datei an den Kalender weiter.
   * data: bleibt nur als Notnagel fuer Browser ohne Blob-Unterstuetzung.
   */
  function icsHref(text) {
    if (window.Blob && window.URL && window.URL.createObjectURL) {
      try {
        return URL.createObjectURL(new Blob([text], { type: 'text/calendar;charset=utf-8' }));
      } catch (e) {
        if (window.console) console.warn('[closed-shop] Blob nicht moeglich:', e);
      }
    }
    return 'data:text/calendar;charset=utf-8,' + encodeURIComponent(text);
  }

  function initCalendar(root) {
    if (!root || root.dataset.cscCalReady === '1') return;

    var start = new Date(root.dataset.cscStart);
    if (isNaN(start.getTime())) return;

    var minutes = parseInt(root.dataset.cscDuration, 10);
    if (!minutes || minutes < 1) minutes = 60;
    var end = new Date(start.getTime() + minutes * 60000);

    var title = root.dataset.cscTitle || '';
    var details = root.dataset.cscDetails || '';
    var url = root.dataset.cscUrl || '';
    var reminder = parseInt(root.dataset.cscReminder, 10) || 0;

    var googleLink = root.querySelector('[data-csc-google]');
    if (googleLink) {
      googleLink.href =
        'https://calendar.google.com/calendar/render?action=TEMPLATE' +
        '&text=' + encodeURIComponent(title) +
        '&dates=' + toIcsUtc(start) + '/' + toIcsUtc(end) +
        '&details=' + encodeURIComponent(details) +
        (url ? '&location=' + encodeURIComponent(url) : '');
    }

    var icsLink = root.querySelector('[data-csc-ics]');
    if (icsLink) {
      var ics = buildIcs({
        uid: root.dataset.cscUid || 'closed-shop@ladypolitan.de',
        stamp: new Date(),
        start: start,
        end: end,
        title: title,
        details: details,
        url: url,
        reminderMinutes: reminder
      });
      icsLink.href = icsHref(ics);
      icsLink.type = 'text/calendar';

      // Aeltere Safaris kennen download nicht und wuerden die Datei im selben
      // Tab als Text anzeigen. Im neuen Tab bietet iOS stattdessen den
      // Kalender-Import an.
      if (!('download' in document.createElement('a'))) {
        icsLink.target = '_blank';
        icsLink.rel = 'noopener';
      }
    }

    root.dataset.cscCalReady = '1';
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-csc-calendar]');
    for (var i = 0; i < roots.length; i++) initCalendar(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme-Editor: Section wurde neu geladen oder ausgewaehlt
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
